import { Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
// ... outros imports mantidos
import { useCallback, useEffect } from "react";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { ModalLoading } from "../../../../../../common/components/modal_loading";
import PrimaryButton from "../../../../../../common/components/primary_button";
import FormContainer from "../../../../../../common/components/form_container";
import { AlterarInativoAtivoForm, AlterarInativoAtivoSchema } from "../../../schemas/Funcionario_Terc/alterar_inativo_ativo";
import { FormRadioGroupInput } from "../../../../../../common/components/masked_inputs/react_forms/form_radio_group_input";
import { FormDatePickerInput } from "../../../../../../common/components/masked_inputs/react_forms/form_date_picker_input";

type Props = {
  open: boolean;
  saving: boolean;
  onClose: () => void;
  onSubmit: (form: AlterarInativoAtivoForm) => void;
};

export const AlterarInativoAtivoModal = ({
  open,
  saving,
  onClose,
  onSubmit,
}: Props) => {
  const hookForm = useForm<AlterarInativoAtivoForm>({
    mode: 'onSubmit',
    reValidateMode: 'onSubmit',
    resolver: zodResolver(AlterarInativoAtivoSchema),
  });

  const ativoValue = hookForm.watch('Ativo');

  useEffect(() => {
    if (open) hookForm.reset();
  }, [open, hookForm]);

  const handleClose = useCallback(() => {
    if (!saving) onClose();
  }, [saving, onClose]);

  const handleSubmit = useCallback((form: AlterarInativoAtivoForm) => {
    if (form.Ativo === 1) {
        form.DataTermino = null; 
    }
    if (!saving) onSubmit(form);
  }, [saving, onSubmit]);

  return (
    <Dialog
      open={open}
      slotProps={{
        paper: {
          component: 'form',
          onSubmit: hookForm.handleSubmit(handleSubmit),
        }
      }}
      sx={{
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            width: "100%",
            maxWidth: "40rem",
          },
        },
      }}>
      <DialogTitle>
        Alterar Inativo/Ativo
      </DialogTitle>

      <DialogContent>
        <FormContainer title={"Inativar/Ativar Funcionarios"} arrangement="fullRow">
          <ModalLoading loading={saving} message="Salvando...">
            
            <FormRadioGroupInput
              name="Ativo"
              label="Ativo?"
              readOnly={saving}
              options={[
                { id: 0, label: "Inativo" },
                { id: 1, label: "Ativo" },
              ]}
              reactHookForm={hookForm}
            />

            {/* 2. Renderização Condicional: Só mostra se for 0 (Inativo) */}
            {Number(ativoValue) === 0 && (
                <FormDatePickerInput
                  name='DataTermino'
                  label='Data Termino'
                  reactHookForm={hookForm}
                />
            )}

          </ModalLoading>
        </FormContainer>
      </DialogContent>

      <DialogActions>
        <div className="w-full h-full items-center justify-end flex p-4 gap-4">
          <div className="flex flex-row gap-2">
            <div className="p-2 hover:bg-hover-light-gray cursor-pointer dark:hover:bg-border-dark-gray rounded-[4px] font-semibold">
              <h1
                className="text-sm text-black dark:text-white"
                onClick={handleClose}>
                Cancelar
              </h1>
            </div>

            <div className="w-[120px]">
              <PrimaryButton
                type="submit"
                buttonColor="primary-green">
                Salvar
              </PrimaryButton>
            </div>
          </div>
        </div>
      </DialogActions>
    </Dialog>
  );
}